module.exports = __webpack_public_path__ + "media/36.d5b763fe.ogg";